import {UIGameResponsiveController} from '../../../shared/scripts/ui_game/UIGameResponsiveController'
import {UIMGameManager} from './UIMGameManager'

export class UIMGameResponsiveController extends UIGameResponsiveController {
    constructor(uiGameManager: UIMGameManager) {
        super(uiGameManager)
        UIGameResponsiveController.resolutionScale = 2
    }

    // eslint-disable-next-line class-methods-use-this
    protected showVerticalAds(): boolean {
        return false
    }

    // eslint-disable-next-line class-methods-use-this
    protected showHorizontalAds(): boolean {
        return false
    }

    getScaleForRotation(): number {
        return window.innerWidth / this.uiGameManager.canvasController.appW
    }

    // eslint-disable-next-line class-methods-use-this
    getAppWnH(): {w: number, h: number} {
        const w = window.innerWidth
        const h = window.innerHeight

        return {w: w, h: h}
    }

    // eslint-disable-next-line class-methods-use-this
    getCanvasY(): number {
        return 0
    }

    // eslint-disable-next-line class-methods-use-this
    getCanvasX(): number {
        return 0
    }

    buildRenderer() {
        const size = this.getAppWnH()
        this.uiGameManager.canvasController.app.renderer.resize(size.w, size.h)
        this.uiGameManager.canvasController.app.view.style.top = '0%'
    }
}
